import { render, staticRenderFns } from "./QuickProfileUpdate.vue?vue&type=template&id=961627de"
import script from "./QuickProfileUpdate.vue?vue&type=script&lang=js"
export * from "./QuickProfileUpdate.vue?vue&type=script&lang=js"
import style0 from "./QuickProfileUpdate.vue?vue&type=style&index=0&id=961627de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports